module.exports = "/fonts/vendor/bootstrap-icons/bootstrap-icons.woff2?3518ff4dccdeac177ccf83b9380dab8e";